export const PHONE_REGEX = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/
export const GETSTREAM_IMAGE_REGEX = /.*stream.*/
export const HYPERLINK_REGEX = /<a href=("|')(.+?)("|')>(.+?)<\/a>/
export const URL_REGEX =
  /^(https?:\/\/|www\.)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(:\d+)?(\/.*)?$/
